import { Box, Typography } from "@mui/material";
import { motion } from "motion/react";
import LetterTypewriter from "../../components/Typewriter";
// import Logo from "../../assets/download.png";

const CoverPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Box
        id="cover"
        sx={{
          justifyContent: "center",
          width: "100%",
          pt: "150px",
        }}
      >
        <Box>
          <Typography variant="h2"> About Me</Typography>
          <Typography
            variant="h5"
            sx={{
              padding: { xs: 2, md: 3 },
            }}
          >
            {/* Welcome and thanks for visiting my website. */}
            {/* Growing up in a SMB I've always been interested in 
            growing businesses. When I entered college, I did not know what I wanted to study but I knew I 
            didn't want to study business because I believed that you couldn't study business instead you learned
            about business from doing so I wanted to pick up some other skills that would help me in business.  */}
            {/* I am based in NYC.  */}
            {/* I studied computer science at NYU Shanghai. */}
            <LetterTypewriter
              phrases={[
                "Product Enthusiast",
                "Systems Engineer",
                "I like building",
              ]}
              typingSpeed={80}
              deletingSpeed={30}
              delayBetween={1500}
            />
            I am interested in full stack development and building products that
            have intuitive, easy-to-use user experiences. When I am not coding,
            I like to play basketball or go on a run.
          </Typography>
        </Box>
        {/* <Box>
          <Typography variant="h2">Education</Typography>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex">
              <img src={Logo} alt="" width={100} />
              <Box
                sx={{
                  padding: { xs: 2, md: 3 },
                }}
              >
                <Typography variant="h3">
                  New York University Shanghai
                </Typography>
                <Typography variant="h7">
                  Bachelors of Science in Computer Science
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="h3"
              sx={{
                padding: { xs: 2, md: 4 },
              }}
            >
              2024
            </Typography>
          </Box>
        </Box> */}
      </Box>
    </motion.div>
  );
};

export default CoverPage;
